/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamAnalysisTaskItemAreaDataDto } from './BeamAnalysisTaskItemAreaDataDto';
import {
    instanceOfBeamAnalysisTaskItemAreaDataDto,
    BeamAnalysisTaskItemAreaDataDtoFromJSON,
    BeamAnalysisTaskItemAreaDataDtoFromJSONTyped,
    BeamAnalysisTaskItemAreaDataDtoToJSON,
} from './BeamAnalysisTaskItemAreaDataDto';

/**
 * @type TaskItemAreaDataDto
 * 
 * @export
 */
export type TaskItemAreaDataDto = { $type?: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.BeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application' } & BeamAnalysisTaskItemAreaDataDto;


export function TaskItemAreaDataDtoFromJSON(json: any): TaskItemAreaDataDto {
    return TaskItemAreaDataDtoFromJSONTyped(json, false);
}

export function TaskItemAreaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDataDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.BeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application':
            return Object.assign({}, BeamAnalysisTaskItemAreaDataDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.BeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application' } as const);
        default:
            throw new Error(`No variant of TaskItemAreaDataDto exists with '$type=${json['$type']}'`);
    }
}

export function TaskItemAreaDataDtoToJSON(value?: TaskItemAreaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.BeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application':
            return BeamAnalysisTaskItemAreaDataDtoToJSON(value);
        default:
            throw new Error(`No variant of TaskItemAreaDataDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TaskItemAreaDataDto interface.
 */
export function instanceOfTaskItemAreaDataDto(value: any): value is TaskItemAreaDataDto {
    if (instanceOfBeamAnalysisTaskItemAreaDataDto(value)) return true;
    return false;
}

